import React from 'react'

import { Suspense } from '~/components/elements/Suspense'

import { Restore } from './components/Restore'
import { useMainQuery } from './hooks/useMainQuery'

export const RestorePage = () => {
  const { isLoading } = useMainQuery()

  return (
    <Suspense loading={isLoading}>
      <Restore />
    </Suspense>
  )
}
